export default __webpack_public_path__ + "static/media/Substrates-Connect.3bff3eb3.svg";